// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c16a8ebc","488":"1fc09a0d","977":"8ae6261c"}[chunkId] + ".chunk.js";
};